import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { FullLoading } from "../../components/Loading/Loading";
import { LoadingContext } from "../../providers/LoadingContextProvider";
function Page({ children }) {
    const { state: { fullPageLoading }, } = useContext(LoadingContext);
    return (_jsx("div", { className: "wpqt-pr-4", children: fullPageLoading ? _jsx(FullLoading, {}) : children }));
}
export { Page };
